export default "__VITE_ASSET__82b9c4c3__"